@if (display && control) {
  <div [formGroup]="internalForm">
    <mat-form-field class="w-100">
      @if (helpText) {
        <app-help-text [dataContext]="helpText"></app-help-text>
      }
      <input
        matInput
        autocomplete="off"
        [matDatepicker]="picker"
        [errorStateMatcher]="errorStateMatcher"
        [placeholder]="control.caption | translate"
        [readonly]="control.isReadonly"
        [required]="control.required"
        [formControlName]="'date'"
        [ngClass]="{ locked: control.isReadonly }"
        (keyup)="onKeyUp($event)"
        (dateChange)="onDateChange($event.target.value)"
        (blur)="onblur()"
        (focus)="onfocus()"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker [disabled]="control.isReadonly"></mat-datepicker>
        @if (errorMessage) {
          <mat-error>{{ errorMessage.message | translate: errorMessage.params }}</mat-error>
        }
      </mat-form-field>
    </div>
  }
